import React from 'react';
import { StyledPeopleCell } from './StyledPeopleCell';

const PeopleCell = ({ image, name, position }) => {
  return (
    <React.Fragment>
      {
        <StyledPeopleCell>
          <img src={image} />
          <p className="preset-10 people--name">{name}</p>
          <p className="preset-11">{position}</p>
        </StyledPeopleCell>
          
      }
    </React.Fragment>
  );
};

export default PeopleCell;
